import { Middleware } from '@reduxjs/toolkit';
import { SPMasterAdminAnonymousApi } from '../../../Apis/Anonymous';
import { SPCommonServicesApi } from '../../../Apis/Common';

const mutationMiddleware: Middleware = (api) => (next) => (action: any) => {
  // Bypass actions this middleware dispatches itself
  if (action.meta?.fromMutationMiddleware) return next(action);

  if (
    action.type.endsWith('/fulfilled') &&
    action.meta?.arg?.type === 'mutation'
  ) {
    // Dispatch with a special meta to avoid recursion
    api.dispatch({
      ...SPCommonServicesApi.util.invalidateTags(['CommonService']),
      meta: { fromMutationMiddleware: true },
    });
    api.dispatch({
      ...SPMasterAdminAnonymousApi.util.invalidateTags([
        'AnonymousCommonService',
      ]),
      meta: { fromMutationMiddleware: true },
    });
  }

  return next(action);
};

export default mutationMiddleware;
